/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setToast } from '../../../store/ToastManagement';
import {
  Container,
  Grid,
  Segment,
  Form,
  Header,
  Input,
  Button,
  Checkbox,
  TextArea
} from 'semantic-ui-react';
import { useCurrentUser } from '../../../_services/hooks/user';
import { servicesAPI, uploadFile, useCustomer } from '../../../_services';
import { AONNavSteps } from '../../../_components/layout/AON';
import { filenameDateTime } from '../../../utils';
import '../../../_components/layout/AON.css';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);


const Survey = ({ surveyId, auth, survey, customerId, steps }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const urlStep = params.get('step');

  const { currentUserIsCustomer } = useCurrentUser();
  const [init, setInit] = useState(true);
  const [completed, setCompleted] = useState(false);
  const [responses, setResponses] = useState(Array(steps.length));
  const [stepId, setStepId] = useState(0);
  const [step, setStep] = useState({});
  const [hover, setHover] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [enableNextStep, setEnableNextStep] = useState(true);
  const [responseSelection, setResponseSelection] = useState(null);
  const [responseText, setResponseText] = useState('');
  const [responseUploadPhoto, setResponseUploadPhoto] = useState(null);
  const [responseUploadPhoto2, setResponseUploadPhoto2] = useState(null);
  const [responseUploadVideo, setResponseUploadVideo] = useState(null);

  const [confirmAccuracy, setConfirmAccuracy] = useState(false);

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  useEffect(() => {
    if (!init || !survey) return;

    const completed = false; // BANANA survey.status !== 'IN_PROGRESS';
    setCompleted(completed);
    if (survey.responses) setResponses(survey.responses);

    if (completed) {
      setStepId(steps.length - 1);
    } else if (urlStep) {
      // Resume from specific step?
      const stepId = parseInt(urlStep) - 1;
      setStepId(stepId);
    } else {
      for (let i = survey.responses.length - 1; i >= 0; --i) {
        const response = survey.responses[i];
        if (response) {
          setStepId(i + 1);
          break;
        }
      }
    }

    setInit(false);

    // Limit it to number of steps completed so far
    // if (stepId === 0 || responses[stepId]) setStepId(stepId);
  }, [init, survey, urlStep]);

  useEffect(() => {
    const step = steps[stepId];
    if (!step) return;

    const isQuestion = ['SELECT', 'MULTISELECT', 'NUMBER', 'TEXT_PHOTO_VIDEO', 'TEXT_PHOTO', 'UPLOAD_PHOTO', 'UPLOAD_PHOTOS', 'UPLOAD_VIDEO'].includes(step?.type);

    const response = responses[stepId];
    if (response) {
      if (step.type === 'SELECT' || step.type == 'MULTISELECT') {
        setResponseSelection(response.response);
      } else if (step.type === 'NUMBER') {
        setResponseText(response.response);
      } if (step.type === 'TEXT_PHOTO_VIDEO') {
        setResponseText(response.response.text);
        setResponseUploadPhoto(response.response.photo);
        setResponseUploadVideo(response.response.video);
      } if (step.type === 'TEXT_PHOTO') {
        setResponseText(response.response.text);
        setResponseUploadPhoto(response.response.photo);
      } else if (step.type === 'UPLOAD_PHOTO') {
        setResponseUploadPhoto(response.response);
      } else if (step.type === 'UPLOAD_PHOTOS') {
        setResponseUploadPhoto(response.response.photo1);
        setResponseUploadPhoto2(response.response.photo2);
      } else if (step.type === 'UPLOAD_VIDEO') {
        setResponseUploadVideo(response.response);
      }

      setEnableNextStep(true);
    } else {
      setResponseSelection(null);
      setResponseText('');
      setResponseUploadPhoto(null);
      setResponseUploadPhoto2(null);
      setResponseUploadVideo(null);

      setEnableNextStep(!isQuestion || step?.optional === true);
    }

    setConfirmAccuracy(false);

    setStep(step);

    params.set('step', stepId + 1);
    const url = location.pathname + '?' + params.toString();
    window.history.replaceState(null, null, url)
  }, [stepId]);

  const submitResponse = stepId => {
    const step = steps[stepId];

    if (step.type === 'END') {
      if (!completed) {
        completeSurvey();
      } else {
        if (currentUserIsCustomer)
          document.location.href = '/customer/dashboard';
        else
          document.location.href = '/login';
      }
    } else if (step.type === 'SELECT' || step.type === 'MULTISELECT') {
      recordResponse(stepId, responseSelection);
    } else if (step.type === 'NUMBER') {
      recordResponse(stepId, responseText);
    } else if (['TEXT_PHOTO_VIDEO', 'TEXT_PHOTO', 'UPLOAD_PHOTO', 'UPLOAD_PHOTOS', 'UPLOAD_VIDEO'].includes(step.type)) {
      let files = [];

      if (step.type === 'TEXT_PHOTO_VIDEO') {
        recordResponse(stepId, {
          text: responseText,
          photo: responseUploadPhoto,
          video: responseUploadVideo
        });
        files.push({ file: responseUploadPhoto, suffix: '' });
        files.push({ file: responseUploadVideo, suffix: '' });
      } else if (step.type === 'TEXT_PHOTO') {
        recordResponse(stepId, {
          text: responseText,
          photo: responseUploadPhoto
        });
        files.push({ file: responseUploadPhoto, suffix: '' });
      } else if (step.type === 'UPLOAD_PHOTO') {
        recordResponse(stepId, responseUploadPhoto);
        files.push({ file: responseUploadPhoto, suffix: '' });
      } else if (step.type === 'UPLOAD_PHOTOS') {
        recordResponse(stepId, {
          photo1: responseUploadPhoto,
          photo2: responseUploadPhoto2
        });
        files.push({ file: responseUploadPhoto, suffix: '1' });
        files.push({ file: responseUploadPhoto2, suffix: '2' });
      } else if (step.type === 'UPLOAD_VIDEO') {
        recordResponse(stepId, responseUploadVideo);
        files.push({ file: responseUploadVideo, suffix: '' });
      }

      files.forEach(info => {
        const f = info.file;
        const suffix = info.suffix;

        if (!f) return;

        // Upload media
        const file = f[0];

        if (!file) return;
        
        const re = /(?:\.([^.]+))?$/;
        const ext = re.exec(file.name)[1];

        const folder = 'aonSurvey/' + surveyId;
        const fileData = f[0];
        const fileName = step.name + suffix + '.' + ext;

        uploadFile(fileData, fileName, folder, () => {})
          .then(response => {
            setUploading(false);
          })
          .catch(e => {
            setUploading(false);
          });
      });
    }
  };

  const recordResponse = (stepId, response) => {
    const step = steps[stepId];
    let newResponses = [...responses];
    newResponses[stepId] = {
      name: step.name,
      type: step.type,
      question: step.heading,
      response: response
    };
    setResponses(newResponses);

    // Save progress
    upsertSurvey(newResponses);
  };

  const getSurvey = () => {
    servicesAPI.AdminServices('getSurvey', surveyId, customerId, auth).then(survey => {
      if (survey) {
        survey = {
          ...survey,
          ...JSON.parse(survey.data)
        };
        setResponses(survey.responses);
      }
    });
  };

  const completeSurvey = () => {
    const datetime = moment().format('YYYY-MM-DDTHH:mm:00') + ',Z';
    const values = {
      id: surveyId,
      datetime: datetime,
      auth: auth,
      customer_id: customerId,
      responses: responses,
      status: 'SUBMITTED'
    };

    servicesAPI.AdminServices('upsertSurvey', values, surveyId).then(
      response => {
        displayMessage('Success', 'Submitted survey responses. Thank you!', true);

        if (currentUserIsCustomer)
          document.location.href = '/customer/dashboard';
        else
          document.location.href = '/login';
      },
      error => {
        displayMessage('Error', 'Failed to submit survey. Please try again later', false);
      }
    );
  };

  const upsertSurvey = responses => {
    const datetime = moment().format('YYYY-MM-DDTHH:mm:00') + ',Z';
    const values = {
      id: surveyId,
      datetime: datetime,
      auth: auth,
      customer_id: customerId,
      responses: responses,
      status: 'IN_PROGRESS'
    };

    servicesAPI.AdminServices('upsertSurvey', values, surveyId);
  };

  return (
    <Container>
      <Grid centered padded>
        <Grid.Column style={{ maxWidth: 880 }}>
          <Segment>
            <div className="aon-modal">
              {stepId < steps.length - 1 ? (
                <AONNavSteps
                  step={stepId + 1}
                  numSteps={steps.length}
                  onPrev={() => {
                    const firstStep = stepId === 0;
                    if (!firstStep) setStepId(stepId - 1);
                  }}
                  onNext={() => {
                    const submitted = responses[stepId];
                    if (enableNextStep || submitted) setStepId(stepId + 1);
                  }}
                />
              ) : ''}
              <div className="aon-header2">
                <span className="aon-header-span-blue2">{step.heading}</span>
              </div>
              <br />
              {(step.question || step.text) ? (
                <div className="aon-frame6">
                  <div
                    className="aon-text-box"
                  >
                    {step.question ? (
                      <span
                        className="aon-text-box-span-bold"
                      >
                        {step.question}
                        <br />
                      </span>
                    ) : (
                      ''
                    )}
                    {step.text ? (
                      <span
                        className="aon-text-box-span-light"
                      >
                        {step.text}
                        <br />
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              ) : ''}
              {step.text2 ? (
                <div className="aon-frame6">
                  <div
                    className="aon-text-box"
                  >
                    <span
                      className="aon-text-box-span-light"
                    >
                      {step.text2}
                      <br />
                    </span>
                  </div>
                </div>
              ) : ''}
              {step.text3 ? (
                <div className="aon-frame6">
                  <div
                    className="aon-text-box"
                  >
                    <span
                      className="aon-text-box-span-light"
                    >
                      {step.text3}
                      <br />
                    </span>
                  </div>
                </div>
              ) : ''}
              {step.text4 ? (
                <div className="aon-frame6">
                  <div
                    className="aon-text-box"
                  >
                    <span
                      className="aon-text-box-span-light"
                    >
                      {step.text4}
                      <br />
                    </span>
                  </div>
                </div>
              ) : ''}
              {step.notes ? (
                <>
                  <div className="aon-frame6">
                    <div
                      className="aon-text-box"
                    >
                      {step.notes ? (
                        <span
                          className="aon-text-box-span-light"
                        >
                          {step.notes}
                          <br />
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <br />
                </>
              ) : ''}
              {step.notes2 ? (
                <>
                  <div className="aon-frame6">
                    <div
                      className="aon-text-box"
                    >
                      {step.notes2 ? (
                        <span
                          className="aon-text-box-span-light"
                        >
                          {step.notes2}
                          <br />
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <br />
                </>
              ) : ''}
              {step.sample ? (
                <>
                  Sample photo
                  <br />
                  <img align="left" src={step.sample} width="100%" alt="Example"/>
                  <br />
                  <br />
                </>
              ) : ''}
              {step.sample2 ? (
                <>
                  Sample photo
                  <br />
                  <img align="left" src={step.sample2} width="100%" alt="Example 2"/>
                  <br />
                  <br />
                </>
              ) : ''}
              {step.type === 'NUMBER' ? (
                <>
                  <div className="aon-frame6">
                    <br />
                    <br />
                    <Input
                      type="number"
                      step="0.01"
                      value={responseText}
                      onChange={(e, inputProps) => {
                        setResponseText(Math.max(parseFloat(inputProps.value), 0));
                        setEnableNextStep(true);
                      }}
                    />
                    {step.units ? step.units : ''}
                  </div>
                  <br />
                </>
              ) : ''}
              {step.type === 'SELECT' ? step.options.map((option, idx) => (
                <div
                  className="aon-frame3"
                  onClick={event => {
                    setResponseSelection(option);
                    setEnableNextStep(true);
                  }}
                >
                  <div>
                    {option === responseSelection ? (
                      <span className="aon-text-box-span-bold">
                        {option}
                        <br />
                      </span>
                    ) : (
                      <span className="aon-text-box-span-light">
                        {option}
                        <br />
                      </span>
                    )}
                  </div>
                  <br />
                </div>
              )) : ''}
              {step.type === 'MULTISELECT' ? step.options.map((option, idx) => (
                <div
                  className={Math.pow(2, idx) & responseSelection ? "aon-frame3-selected" : "aon-frame3"}
                  onClick={event => {
                    const optionBit = Math.pow(2, idx);
                    let selection = responseSelection;
                    let wasSelected = false;

                    if (selection)
                      wasSelected = selection & optionBit;
                    else
                      selection = 0;

                    // Toggle selection
                    if (wasSelected)
                      selection &= ~optionBit;
                    else
                      selection |= optionBit;

                    setResponseSelection(selection);
                    setEnableNextStep(selection !== 0);
                  }}
                >
                  <div>
                    {Math.pow(2, idx) & responseSelection ? (
                      <span className="aon-text-box-span-bold">
                        {option}
                        <br />
                      </span>
                    ) : (
                      <span className="aon-text-box-span-light">
                        {option}
                        <br />
                      </span>
                    )}
                  </div>
                  <br />
                </div>
              )) : ''}
              {step.type === 'TEXT_PHOTO' ? (
                <>
                  <div className="aon-frame5">
                    <TextArea
                      value={responseText}
                      placeholder={step.placeholder}
                      onChange={(e, inputProps) => {
                        setResponseText(inputProps.value);
                        setEnableNextStep(true);
                      }}
                      style={{ width: '100%', minHeight: '100px' }}
                    />
                  </div>
                  <br />
                  <div className="aon-frame6">
                    <div>
                      {responseUploadPhoto && responseUploadPhoto.length ? <img id="photo" src={URL.createObjectURL(responseUploadPhoto[0])} alt="photo" /> : ''}
                    </div>
                    <input
                      id="select-photo"
                      className="aon-file-upload"
                      type="file"
                      accept="image/*"
                      onChange={event => {
                        setResponseUploadPhoto(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <input
                      id="capture-photo"
                      className="aon-file-upload"
                      type="file"
                      accept="image/*"
                      capture="environment"
                      onChange={event => {
                        setResponseUploadPhoto(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <label for="select-photo" className="aon-custom-file-upload">
                      {(responseUploadPhoto && responseUploadPhoto.length) ? responseUploadPhoto[0].name : 'Select photo'}
                    </label>
                    <label for="capture-photo" className="aon-custom-file-upload">Take photo (mobile)</label>
                    <br />
                  </div>
                  <br />
                </>
              ) : ''}
              {step.type === 'TEXT_PHOTO_VIDEO' ? (
                <>
                  <div className="aon-frame5">
                    <TextArea
                      value={responseText}
                      placeholder={step.placeholder}
                      onChange={(e, inputProps) => {
                        setResponseText(inputProps.value);
                        setEnableNextStep(true);
                      }}
                      style={{ width: '100%', minHeight: '100px' }}
                    />
                  </div>
                  <br />
                  <div className="aon-frame6">
                    <div>
                      {responseUploadPhoto && responseUploadPhoto.length ? <img id="photo" src={URL.createObjectURL(responseUploadPhoto[0])} alt="photo" /> : ''}
                    </div>
                    <input
                      id="select-photo"
                      className="aon-file-upload"
                      type="file"
                      accept="image/*"
                      onChange={event => {
                        setResponseUploadPhoto(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <input
                      id="capture-photo"
                      className="aon-file-upload"
                      type="file"
                      accept="image/*"
                      capture="environment"
                      onChange={event => {
                        setResponseUploadPhoto(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <label for="select-photo" className="aon-custom-file-upload">
                      {(responseUploadPhoto && responseUploadPhoto.length) ? responseUploadPhoto[0].name : 'Select photo'}
                    </label>
                    <label for="capture-photo" className="aon-custom-file-upload">Take photo (mobile)</label>
                    <br />
                  </div>
                  <br />
                  <div className="aon-frame6">
                    {/*<div>
                      {responseUploadVideo && responseUploadVideo.length ? <img id="video" src={URL.createObjectURL(responseUploadVideo[0])} alt="video" /> : ''}
                    </div>*/}
                    <input
                      id="select-video"
                      className="aon-file-upload"
                      type="file"
                      accept="video/*"
                      onChange={event => {
                        setResponseUploadVideo(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <input
                      id="capture-video"
                      className="aon-file-upload"
                      type="file"
                      accept="video/*"
                      capture="environment"
                      onChange={event => {
                        setResponseUploadVideo(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <label for="select-video" className="aon-custom-file-upload">
                      {(responseUploadVideo && responseUploadVideo.length) ? responseUploadVideo[0].name : 'Select video'}
                    </label>
                    <label for="capture-video" className="aon-custom-file-upload">Take video (mobile)</label>
                    <br />
                  </div>
                  <br />
                </>
              ) : ''}
              {step.type === 'UPLOAD_PHOTO' ? (
                <>
                  <div>
                    {responseUploadPhoto && responseUploadPhoto.length ? <img id="photo" src={URL.createObjectURL(responseUploadPhoto[0])} alt="photo" /> : ''}
                  </div>
                  <div className="aon-frame6">
                    <input
                      id="select-photo"
                      className="aon-file-upload"
                      type="file"
                      accept="image/*"
                      onChange={event => {
                        setResponseUploadPhoto(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <input
                      id="capture-photo"
                      className="aon-file-upload"
                      type="file"
                      accept="image/*"
                      capture="environment"
                      onChange={event => {
                        setResponseUploadPhoto(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <label for="select-photo" className="aon-custom-file-upload">Select photo</label>
                    <label for="capture-photo" className="aon-custom-file-upload">Take photo (mobile)</label>
                    <br />
                  </div>
                  <br />
                </>
              ) : ''}
              {step.type === 'UPLOAD_PHOTOS' ? (
                <>
                  <div>
                    {responseUploadPhoto && responseUploadPhoto.length ? <img id="photo" src={URL.createObjectURL(responseUploadPhoto[0])} alt="photo" /> : ''}
                  </div>
                  <div className="aon-frame6">
                    {responseUploadPhoto && responseUploadPhoto.length ? (
                      <label for="select-photo" className="aon-custom-file-upload">
                        {responseUploadPhoto[0].name}
                      </label>
                    ) : (
                      <>
                        <input
                          id="select-photo"
                          className="aon-file-upload"
                          type="file"
                          accept="image/*"
                          onChange={event => {
                            setResponseUploadPhoto(event.target.files);
                            setEnableNextStep(true);
                          }}
                        />
                        <input
                          id="capture-photo"
                          className="aon-file-upload"
                          type="file"
                          accept="image/*"
                          capture="environment"
                          onChange={event => {
                            setResponseUploadPhoto(event.target.files);
                            setEnableNextStep(true);
                          }}
                        />
                        <label for="select-photo" className="aon-custom-file-upload">Select photo 1</label>
                        <label for="capture-photo" className="aon-custom-file-upload">Take photo 1 (mobile)</label>
                      </>
                    )}
                    <br />
                  </div>
                  <br />
                  {step?.count > 1 ? (
                    <>
                      <div>
                        {responseUploadPhoto2 && responseUploadPhoto2.length ? <img id="photo2" src={URL.createObjectURL(responseUploadPhoto2[0])} alt="photo" /> : ''}
                      </div>
                      <div className="aon-frame6">
                        {responseUploadPhoto2 && responseUploadPhoto2.length ? (
                          <label for="select-photo2" className="aon-custom-file-upload">
                            {responseUploadPhoto2[0].name}
                          </label>
                        ) : (
                          <>
                            <input
                              id="select-photo2"
                              className="aon-file-upload"
                              type="file"
                              accept="image/*"
                              onChange={event => {
                                setResponseUploadPhoto2(event.target.files);
                                setEnableNextStep(true);
                              }}
                            />
                            <input
                              id="capture-photo2"
                              className="aon-file-upload"
                              type="file"
                              accept="image/*"
                              capture="environment"
                              onChange={event => {
                                setResponseUploadPhoto2(event.target.files);
                                setEnableNextStep(true);
                              }}
                            />
                            <label for="select-photo2" className="aon-custom-file-upload">Select photo 2</label>
                            <label for="capture-photo2" className="aon-custom-file-upload">Take photo 2 (mobile)</label>
                          </>
                        )}
                        <br />
                      </div>
                      <br />
                    </>
                  ) : ''}
                </>
              ) : ''}
              {step.type === 'UPLOAD_VIDEO' ? (
                <>
                  {/*<div>
                    {responseUploadVideo && responseUploadVideo.length ? <img id="video" src={URL.createObjectURL(responseUploadVideo[0])} alt="video" /> : ''}
                  </div>*/}
                  <div className="aon-frame6">
                    <input
                      id="select-video"
                      className="aon-file-upload"
                      type="file"
                      accept="video/*"
                      onChange={event => {
                        setResponseUploadVideo(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <input
                      id="capture-video"
                      className="aon-file-upload"
                      type="file"
                      accept="video/*"
                      capture="environment"
                      onChange={event => {
                        setResponseUploadVideo(event.target.files);
                        setEnableNextStep(true);
                      }}
                    />
                    <label for="select-video" className="aon-custom-file-upload">
                      {(responseUploadVideo && responseUploadVideo.length) ? responseUploadVideo[0].name : 'Select video'}
                    </label>
                    <label for="capture-video" className="aon-custom-file-upload">Take video (mobile)</label>
                  </div>
                  <br />
                </>
              ) : ''}
              {step.confirm ? (
                <>
                  <Checkbox
                    label={step.confirm}
                    checked={confirmAccuracy}
                    onChange={(e, data) => setConfirmAccuracy(!confirmAccuracy)}
                  />
                  <br />
                </>
              ) : ''}
              <br />
              <span className="aon-buttons">
                <div
                  className="aon-button"
                  onMouseEnter={()=>setHover(true)}
                  onMouseLeave={()=>setHover(false)}
                  style={{
                    ...(hover ? { cursor: 'pointer', backgroundImage: (enableNextStep && (!step.confirm || confirmAccuracy) && !uploading) ? 'url("/images/aon/button-background-hover.svg")' : 'url("/images/aon/button-grey-background.svg")' } : { backgroundImage: (enableNextStep && (!step.confirm || confirmAccuracy) && !uploading) ? 'url("/images/aon/button-background.svg")' : 'url("/images/aon/button-grey-background.svg")' })
                  }}
                  onClick={event => {
                    if (enableNextStep && (!step.confirm || confirmAccuracy) && !uploading) {
                      submitResponse(stepId);
                      setStepId(stepId + 1);
                    }
                  }}
                >
                  {enableNextStep && (!step.confirm || confirmAccuracy) ? (
                    <div className="aon-button-text">
                      {step.buttonText}
                    </div>
                  ) : (
                    <div className="aon-button-grey">
                      {step.buttonText}
                    </div>
                  )}
                </div>
              </span>
              <br />
              {step.footer ? (
                <>
                  {step.footer}
                  <br />
                </>
              ) : (
                ''
              )}
            </div>
          </Segment>
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export const AONSurvey = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const customerId = params.get('id');
  const auth = params.get('auth');
  const surveyId = 'AONSurvey_' + customerId;

  const [authenticated, setAuthenticated] = useState(null);
  const [survey, setSurvey] = useState(null);

  useEffect(() => {
    // Check if survey has already been submitted
    servicesAPI.AdminServices('getSurvey', surveyId, customerId, auth).then(survey => {
      if (survey) {
        survey = {
          ...survey,
          ...JSON.parse(survey.data)
        };
        setSurvey(survey);
      }
    });

    // Get or create AON survey
    servicesAPI.AdminServices('getAonSurvey', customerId, auth).then(survey => {
      setAuthenticated(auth === survey.auth);
    });
  }, []);

  // if (authenticated === null) return <div>Loading survey</div>;
  if (authenticated === null) return <div></div>;

  // if (!authenticated) return <div>Unable to load survey</div>;
  if (!authenticated) return <div></div>;

  const steps = [
    {
      type: 'START',
      heading: "Let's begin your self survey!",
      text: "You will need to take some pictures and videos for us.",
      text2: "Don't worry if you can't complete the whole survey right now, your progress will be saved and you can pick up where you left off later.",
      buttonText: 'Start...',
      footer: 'Takes about 10 minutes'
    },
    // Section 1 – Trojan Energy Equipment
    {
      questionNo: 14,
      name: 'SupplyUnitToFrontDoor',
      type: 'UPLOAD_VIDEO',
      heading: 'Help us to understand the layout of the electrics in your home.',
      text: 'Please take a video that shows the journey from your consumer unit to the pavement outside your home where we would install the charge point.',
      text2: 'This video should finish looking back towards your home from the street.',
      text3: 'Your consumer unit should look like the picture below. It is typically found under the stairs, in your hallway, by your front door, or on the outside wall of your house.',
      sample: '/images/aon/consumer_unit_zoom_out.png',
      buttonText: 'Next.....'
    },
    {
      questionNo: 15,
      name: 'FrontDoorToPublicFootway',
      type: 'UPLOAD_PHOTOS',
      count: 2,
      heading: "Please take photos of your front garden or the area in front of your property.",
      buttonText: 'Next.....'
    },
    {
      questionNo: 16,
      name: 'PublicFootway',
      type: 'UPLOAD_PHOTOS',
      count: 2,
      heading: "Please take a photo of the pavement outside your house, where we would install your EV charge point.",
      text: "You can provide up to 2 photos if you'd like.",
      buttonText: 'Next.....'
    },
    {
      questionNo: 17,
      name: 'PublicFootwayWidth',
      type: 'NUMBER',
      units: 'metres',
      heading: "Please measure the width of the pavement, in meters, from the property edge (wall, fence, grass verge, etc) to the outer edge of the pavement, closest to the road. See the photo below for an example.",
      text: "Please be as accurate as possible, as this measurement is used to ensure we meet council requirements. If the pavement is different to the width stated here, we may not be able to install.",
      sample: '/images/aon/footway_width.png',
      buttonText: 'Next.....'
    },
    // Section 2 – Electrical Supply
    {
      questionNo: 4,
      name: 'ElectricitySupplyLocation',
      type: 'SELECT',
      heading: 'Where is your consumer unit located?',
      text: "Your consumer unit should look like the picture below. It is typically found under the stairs, in your hallway, by your front door, or on the outside wall of your house.",
      options: [
        'Inside the property',
        'Outside the property',
        'Garage',
        'Other'
      ],
      sample: '/images/aon/consumer_unit_zoom_out\.png',
      buttonText: 'Next.....'
    },
    {
      questionNo: 6,
      name: 'CutOut',
      type: 'UPLOAD_PHOTO',
      heading: 'Please take a picture of your cut-out (main fuse).',
      sample: '/images/aon/cut_out.png',
      buttonText: 'Next.....'
    },
    {
      questionNo: 7,
      name: 'ConsumerUnit',
      type: 'UPLOAD_PHOTO',
      heading: "Please take a picture of your consumer unit/fuseboard with all breakers (switches) clearly visible.",
      sample: '/images/aon/consumer_unit_circuit_breakers.png',
      buttonText: 'Next.....'
    },
    {
      questionNo: 8,
      name: 'ConsumerUnitSurroundingArea',
      type: 'UPLOAD_PHOTO',
      heading: "Please take a picture showing any space around your consumer unit. This can be to the side, above, or below.",
      sample: '/images/aon/consumer_unit_free_space.png',
      buttonText: 'Next.....'
    },
    {
      questionNo: 9,
      name: 'ConsumerUnitAttachedToExternalWall',
      type: 'SELECT',
      heading: 'Is your consumer unit/fuseboard attached to an external wall?',
      options: [
        'Yes',
        'No'
      ],
      buttonText: 'Next.....'
    },
    {
      questionNo: 10,
      name: 'MPAN',
      type: 'TEXT_PHOTO',
      optional: true,
      heading: 'Please provide your MPAN number, this can be found on your electricity bill.',
      notes: "It can be found on your electricity bill or on your electricity meter, typically labelled 'MPAN', 'Supply Number' or 'S Number' (1312345678345 in the picture below).",
      notes2: "Please enter your MPAN, or take a photo of your electricity bill or meter if you're not sure.",
      placeholder: 'Enter MPAN here',
      sample: '/images/aon/mpan.png',
      buttonText: 'Next.....'
    },
    {
      questionNo: 11,
      name: 'DistanceSupplyToAonBox',
      type: 'SELECT',
      heading: 'How far from your consumer unit/fuseboard will the Trojan Home box be located? ',
      notes: 'The Trojan Home box provides power to the charger through an underground cable and is connected to the property electricity supply.', notes2: 'Imagine the cable running along the connecting walls (and over door frames if applicable) between the electricity meter and the charger, and estimate this in metres.',
      sample: '/images/aon/aon_box_1.jpg',
      sample2: '/images/aon/aon_box_2.jpg',
      options: [
        '0-3 meters',
        '3-4 meters',
        '4-7 meters',
        '+7 meters'
      ],
      buttonText: 'Next.....'
    },
    // Section 3 – General
    {
      questionNo: 21,
      name: 'InstallationAvailability',
      type: 'MULTISELECT',
      heading: 'If approved, what days of the week would be most suitable for an installation? Please select multiple options.',
      options: [
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI'
      ],
      buttonText: 'Next.....'
    },
    {
      questionNo: 22,
      name: 'FurtherComments',
      type: 'TEXT_PHOTO_VIDEO',
      optional: true,
      heading: 'Please add any other relevant information you feel we need to know to plan your installation.',
      placeholder: 'Enter further information here',
      confirm: 'I confirm that all the above and true and accurate to the best of my knowledge',
      buttonText: 'Next.....'
    },
    {
      type: 'END',
      heading: 'Your Survey is being reviewed',
      text: 'Thank you for completing the survey! The Trojan Team will review the information and be in touch within 10 working days.',
      text2: 'If you began signing up on your computer, please click Next then return to it. Alternatively, click Next to continue signing up on your phone.',
      buttonText: 'Next.....'
    }
  ];

  return (
    <Survey surveyId={surveyId} auth={auth} survey={survey} customerId={customerId} steps={steps} />
  );
};
